

define(['angular', 'squid/index', 'xo-beaver/dist/logger', './resolvers', './language', './helper'], function (angular, squid) {
  return angular.module('xolocale', ['squid', 'beaver', 'locale.resolvers', 'locale.resolvers.language', 'locale.helper']);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-locale/dist/index.js
// module id = ../node_modules/xo-locale/dist/index.js
// module chunks = 0